<template>
<div class="container mt-4" v-if="loading">
    <div class="row no-gutters">
        <div class="col-12">
            <h2 class="font-glacial-bold text-center font-70 text-lowercase title">{{data.titulo}}</h2>
            <h2 class="font-regular text-center mt-3 subtitle">{{data.primeira_descricao}}</h2>
            <h3 class="font-glacial-regular text-center font-18 mt-3">{{data.segunda_descricao}}</h3>
        </div>
    </div>
    
    <div class="slick-cursos pt-4" :style="`min-height: 618px;`">
        <div class="col-12">
            <div ref="observerAlgunsCursos"></div>
            <transition enter-active-class="animated fadeInUp">
                <slick ref="slick" class="cursos mt-3" :options="slickOptions" v-if="cursos && cursos.length && cursos.length != 0 && showObserver">
                    <div class="pr-2 ml-1 mr-1 clickable" v-for="(d, index) in cursos.slice(0, 5)" :key="index">
                        <div class="blog-item border-transparent border-radius-0" @click="goTo(d)">
                            <div class="card-body card text-white card-cursos p-0 border-0 border-radius-0"
                                :style="`background-image: url(${d.imagem})`">
                            </div>

                            <div class="row no-gutters text-overflow">
                                <div class="col-xl-11 col-10 bg-white box-curso">
                                    <h5 class="extra-bold mt-3 ml-3 mb-0 font-glacial-bold box-titulo">
                                        {{d.nome.trim()}}
                                    </h5>
                                    <div class="arrow ml-3 mt-4 mb-4">
                                        <img src="/wp-content/themes/rhiza/src/assets/arrow.png">
                                    </div>
                                    <div>
                                        <div class="font-glacial-regular ml-4 descricao-curso">
                                            {{d.descricao}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </slick>
            </transition>
        </div>
        <div class="row d-flex justify-content-center pb-3 mb-3">
            <b-button variant="ver-todos" class="col-xl-2 mb-1 mt-3 btn-opacidade" to="/cursos">
            </b-button>
        </div>
    </div>
</div>
</template>

<script>
import observer from 'intersection-observer';

export default {
    props: {
        data: null
    },

    data() {
        return {
            showObserver: false,
            loading: true,

            slickOptions: {
                slidesToShow: 3,
                infinite: false,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1025,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 1,
                        }
                    },
                    {
                        breakpoint: 360,
                        settings: {
                            slidesToShow: 1,
                        }
                    },
                ]

                // Any other options that can be got from plugin documentation
            },


            posts: []
        };
    },

    // All slick methods can be used too, example here
    methods: {
        goTo(data){
            this.$router.push({name: 'curso', params: {slug: data.slug, area: data.area}})
        },

        clicked(data){
            if (data.link){
                if(data.link.includes('http:')){
                    window.open(data.link)
                } else {
                    window.location.replace(data.link)
                }
            } else {
                if(data.video){
                    this.$store.commit('setVideoId', data.video)
                    this.$root.$emit('bv::show::modal','video-modal')
                }
            }
        },

        next() {
            this.$refs.slick.next();
        },

        prev() {
            this.$refs.slick.prev();
        },

        reInit() {
            // Helpful if you have to deal with v-for to update dynamic lists
            this.$nextTick(() => {
                this.$refs.slick.reSlick();
            });
        },

        // Events listeners
        handleAfterChange(event, slick, currentSlide) {
            console.log('handleAfterChange', event, slick, currentSlide);
        },
        handleBeforeChange(event, slick, currentSlide, nextSlide) {
            console.log('handleBeforeChange', event, slick, currentSlide, nextSlide);
        },
        handleBreakpoint(event, slick, breakpoint) {
            console.log('handleBreakpoint', event, slick, breakpoint);
        },
        handleDestroy(event, slick) {
            console.log('handleDestroy', event, slick);
        },
        handleEdge(event, slick, direction) {
            console.log('handleEdge', event, slick, direction);
        },
        handleInit(event, slick) {
            console.log('handleInit', event, slick);
        },
        handleReInit(event, slick) {
            console.log('handleReInit', event, slick);
        },
        handleSetPosition(event, slick) {
            console.log('handleSetPosition', event, slick);
        },
        handleSwipe(event, slick, direction) {
            console.log('handleSwipe', event, slick, direction);
        },
        handleLazyLoaded(event, slick, image, imageSource) {
            console.log('handleLazyLoaded', event, slick, image, imageSource);
        },
        handleLazeLoadError(event, slick, image, imageSource) {
            console.log('handleLazeLoadError', event, slick, image, imageSource);
        },

        async loadImg(url){
            let img = new Image();
            img.src = url
        },
    },

    mounted(){
        var ob = new IntersectionObserver((entries) => {
            // If intersectionRatio is 0, the target is out of view
            // and we do not need to do anything.
            if (entries[0].intersectionRatio <= 0) {
                return;
            }
            this.showObserver = true
            ob.unobserve(this.$refs.observerAlgunsCursos)

        });
        ob.POLL_INTERVAL = 100;
        ob.observe(this.$refs.observerAlgunsCursos)
    },

    computed:{
        cursos(){
            if (!this.$store.state.post.cursosApi) {
                return []
            }

            return this.$store.state.post.cursosApi.sort(() => Math.random() - 0.5);
            this.posts.forEach(e => {
                this.loadImg(e.imagem)
            });
        },
        cursosOrdened(){
            return Array.from(new Set(this.$store.state.post.cursosApi.map(e => e.area)))
            
        },
        
    }
}    
</script>



// WEBPACK FOOTER //
// src/components/widgets/alguns_cursos.vue